const configured = (import.meta.env.VITE_STORE_API_URL as string | undefined)?.replace(/\/$/, "");
const base = import.meta.env.DEV ? "/local-affiliates" : configured;
const CART_ID_KEY = "rt_cart_id";

export function getCartId(): string {
  try {
    let id = localStorage.getItem(CART_ID_KEY);
    if (!id) {
      id = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(CART_ID_KEY, id);
    }
    return id;
  } catch {
    return "no-storage";
  }
}

// Mesma regra do servidor (cart-tracking.php): e-mail válido ou telefone com
// DDD (10–11 dígitos) ou já com 55 (12–13). Sem isso o carrinho é anônimo e
// nem vale a pena enviar: o painel só lista carrinhos identificados.
export function hasCartContact(email?: string, phone?: string): boolean {
  if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return true;
  const digits = (phone ?? "").replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 13;
}

export function sendCartSnapshot(payload: {
  items: { name: string; quantity: number }[];
  subtotal: number;
  email?: string;
  name?: string;
  phone?: string;
}): void {
  if (!base) return;
  if (!hasCartContact(payload.email, payload.phone)) return;
  const cartId = getCartId();
  if (cartId === "no-storage") return;
  // Best-effort: nunca deve interferir na navegação da loja.
  fetch(`${base}/cart-tracking.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cart_id: cartId, items: payload.items, subtotal: payload.subtotal.toFixed(2), email: payload.email, name: payload.name, phone: payload.phone }),
  }).catch(() => { /* silencioso */ });
}
